<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>
<script>
export default {
  name: "app",

  provide() {
    return {
      // reload: this.reload,
    };
  },

  data() {
    return {
      isRouterAlive: true,
    };
  },

  methods: {
    reload() {
      this.isRouterAlive = false;
      // console.log(123123131, "diaoyong");
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>
<style lang="scss">
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 6px;
  /*滚动条宽度*/
  height: 12px;
  /*滚动条高度*/
  background-color: white;
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 0px white;
  -webkit-box-shadow: inset 0 0 0px white;
  background-color: rgb(193, 193, 193);
  /*滚动条的背景颜色*/
  border-radius: 20px;
}
.el-table__fixed {
  height: calc(100% - 12px) !important;
}
.el-table__fixed-right {
  height: calc(100% - 12px) !important;
}

.el-table__fixed-right::before,
.el-table__fixed::before {
  background-color: unset !important;
}
</style>
